<template>
  <div>
    <query-builder-group
      ref="group"
      :operators="operators"
      :operands="operands"
      :depth="1"
      :query="query"
      :max-depth="maxDepth"
      @add-group="handleAddGroup"
      @remove-group="handleRemoveGroup"
      @add-rule="handleAddRule"
      @add-subset="handleAddSubset"
      @remove-rule="handleRemoveRule"
      @remove-subset="handleRemoveSubset"
      @change-operand="handleChangeOperand"
      @change-operator="handleChangeOperator"
      @change-value="handleChangeValue"
      @enter-keyup="handleEnterKeyUp"
    />
  </div>
</template>

<script>
import QueryBuilderGroup from './QueryBuilderGroup'

function dupQuery (q) {
  return JSON.parse(JSON.stringify(q))
}
export default {
  components: {
    QueryBuilderGroup
  },

  props: {
    operators: {
      type: Array,
      required: true
    },
    operands: {
      type: Array,
      required: true
    },
    _limits: {
      type: Array,
      default () {
        return [5, 10, 25, 50, 100]
      }
    },
    _query: {
      type: Object,
      default () {
        return {
          logicalOperator: 'All',
          subsets: [],
          children: [
            {
              query: {
                selectedOperator: '',
                type: 'text',
                rule: '',
                value: ''
              }
            }
          ]
        }
      }
    },
    maxDepth: {
      type: Number,
      default: 3
    },
    periodLabel: {
      type: String,
      default: 'periodLabel'
    },
    searchText: {
      type: String,
      default: 'Get Query '
    },
    clearText: {
      type: String,
      default: 'Clear'
    },
    resetText: {
      type: String,
      default: 'Reset'
    }
  },

  data () {
    return {
      startMenu: false,
      endMenu: false,
      limits: this._limits,
      query: dupQuery(this._query)
    }
  },

  watch: {
    query: {
      handler () {
        this.$emit('update:_query', this.query)
      },
      deep: true
    }
  },

  methods: {
    handleClickSearch () {
      this.$emit('search', dupQuery(this.query), true)
    },

    handleClickClear () {
      const query = dupQuery({
        logicalOperator: 'All',
        subsets: [],
        children: [
          {
            query: {
              selectedOperator: '',
              type: 'text',
              rule: '',
              value: ''
            }
          }
        ]
      })
      this.query = query
      this.$emit('clear', query)
    },

    handleClickReset () {
      const query = dupQuery(this._query)
      this.query = query
      this.$emit('reset', query)
    },

    handleEnterKeyUp () {
      this.handleClickSearch()
    },

    handleAddGroup () {
      this.$emit('add-group', ...arguments)
    },

    handleRemoveGroup () {
      this.$emit('remove-group', ...arguments)
    },

    handleAddRule () {
      this.$emit('add-rule', ...arguments)
    },

    handleAddSubset () {
      this.$emit('add-subset', ...arguments)
    },

    handleRemoveRule () {
      this.$emit('remove-rule', ...arguments)
    },

    handleRemoveSubset () {
      this.$emit('remove-subset', ...arguments)
    },

    handleChangeOperand () {
      this.$emit('change-operand', ...arguments)
    },

    handleChangeOperator () {
      this.$emit('change-operator', ...arguments)
    },

    handleChangeValue () {
      this.$emit('change-value', ...arguments)
    }
  }
}
</script>
